import { create } from "zustand";
import { getData } from "../utils/formHelpers";
import { InstallationTypes } from "../../app/types/genericTables.types";

type UseInstallationType = {
  installationList: InstallationTypes[];
  get: (id: InstallationTypes["id"]) => InstallationTypes | undefined;
  query: string;
  setQuery: (query: string) => void;
  fetchAll: () => void;
  loading: boolean;
};

export const useInstallation = create<UseInstallationType>((set, get) => ({
  loading: false,
  installationList: [],
  query: "",
  setQuery: (query) => set({ query }),
  get: (id) =>
    get().installationList.find((installation) => installation.id === id),
  fetchAll: async () => {
    set({ loading: true });
    try {
      const endpoint = "/generic/Instalaciones";
      const { data: response } = await getData(endpoint);
      set(() => ({
        installationList: response,
        loading: false,
      }));
    } catch (error) {
      console.error("Error fetching installationList:", error);
      set({ loading: false });
    }
  },
}));
